import * as API from './apiBase';

let baseList = {
    GetInvoiceType: 'api/InvoiceNew/GetInvoiceType',
    GetInvoiceStatus: 'api/InvoiceNew/GetInvoiceStatus',
    GetConsumptionKind: 'api/InvoiceNew/GetConsumptionKind',
    InvoiceSearch: 'api/InvoiceNew/InvoiceSearch',
    GetInvoiceDetail: 'api/InvoiceNew/GetInvoiceDetail',
}

/*获取发票类型 */
export const GetInvoiceType = (language) => {
    return API.POST(baseList.GetInvoiceType, {
        language
    })
};

export const GetInvoiceStatus = (language) => {
    return API.POST(baseList.GetInvoiceStatus, {
        language
    })
};

/*获取消费类型 */
export const GetConsumptionKind = (language) => {
    return API.POST(baseList.GetConsumptionKind, {
        language
    })
};

/*获取发票检索列表 */
export const InvoiceSearch = (KeyWord, TypeCode, ConsumptionKind, AmountStart, AmountEnd, InvoiceDateStart, InvoiceDateEnd, IsEdit, IsCheckTrue, IsConsecutive, PageIndex, PageSize, language,InvoiceStatus) => {
    return API.POST(baseList.InvoiceSearch, {
        KeyWord,
        TypeCode,
        ConsumptionKind,
        AmountStart,
        AmountEnd,
        InvoiceDateStart,
        InvoiceDateEnd,
        IsEdit,
        IsCheckTrue,
        IsConsecutive,
        PageIndex,
        PageSize,
        language,
        InvoiceStatus
    })
};

/*获取发票明细 */
export const GetInvoiceDetail = (Id, language) => {
    return API.POST(baseList.GetInvoiceDetail, {
        Id,
        language
    })
};

